import styles from './VehicleSelector.module.scss'
import classNames from 'classnames'
import React from 'react'
import CarBrands from '../CarBrands/CarBrands'
import CarModels from '../CarModels/CarModels'
import { selectBrand, selectEngine, selectModel, selectYear, setBrand, setEngine, setModel, setYear } from '@/features/vehicle/vehicleSlice'
import { useAppDispatch } from '@/utils/hooks/useAppDispatch'
import { useAppSelector } from '@/utils/hooks/useAppSelector'
import { DeviceType, useDeviceType } from '@/utils/hooks/useDeviceType'
import CarEngines from '../CarEngines/CarEngines'
import CarModelYears from '../CarModelYears/CarModelYears'
import Button from '@/components/buttons/Button/Button'
import { useTranslation } from 'react-i18next'

type Props = {
  onSelectVehicle: (kTypeId: number) => void
  onBrandSelected?: (brandId: number) => void,
  hideSelectors?: boolean
}

const VehicleSelector = (props: Props) => {
  const dispatch = useAppDispatch()
  const selectedBrand = useAppSelector(selectBrand)
  const selectedModel = useAppSelector(selectModel)
  const selectedYear = useAppSelector(selectYear)
  const selectedEngine = useAppSelector(selectEngine)
  const device = useDeviceType()
  const { t } = useTranslation('common')


  const handleOnSelectedBrand = (value: number) => {
    dispatch(setBrand(value))
    dispatch(setYear(undefined))
    dispatch(setModel(undefined))
    dispatch(setEngine(undefined))

    if (device === DeviceType.Mobile)
      window.scrollTo(0, 0)

    if (props.onBrandSelected)
      props.onBrandSelected(value)
  }

  const handleOnSelectModel = (value: number) => {
    dispatch(setModel(value))
    dispatch(setEngine(undefined))
  }

  const handleOnSelectModelYear = (value: number) => {
    dispatch(setYear(value))
    dispatch(setModel(undefined))
    dispatch(setEngine(undefined))
  }

  const handleOnSelectEngine = (value: number) => {
    dispatch(setEngine(value))

    if (selectedBrand && selectedModel && selectedYear && props.onSelectVehicle)
      props.onSelectVehicle(value)
  }

  const handleManualSearch = () => {
    if (selectedBrand && selectedModel && selectedYear && selectedEngine && props.onSelectVehicle)
      props.onSelectVehicle(selectedEngine)
  }

  const extraStyles = {
    [styles.brandSelected]: selectedBrand
  }

  if (props.hideSelectors) {
    return (<div className={classNames(styles.component)}></div>)
  }

  const showSearchButton = !props.hideSelectors && selectedBrand && selectedEngine

  return (
    <div className={classNames(styles.component, extraStyles)}>
      <CarBrands
        selected={selectedBrand}
        onClick={handleOnSelectedBrand}
      />
      <CarModelYears
        selectedYear={selectedYear}
        onSelectedYear={handleOnSelectModelYear}
      />
      <CarModels
        carBrand={selectedBrand}
        year={selectedYear}
        selectedModel={selectedModel}
        onSelectedModel={handleOnSelectModel}
      />
      <CarEngines
        carModel={selectedModel}
        selectedEngine={selectedEngine}
        onSelectedEngine={handleOnSelectEngine}
      />
      {showSearchButton && (
        <Button
          label={t('search.searchButton')}
          large={true}
          onClick={handleManualSearch}
        />
      )}
    </div>
  )
}

export default VehicleSelector